// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName___OCvl","colMin":"styles_colMin__3L9Tz","colCheckbox":"styles_colCheckbox__1ZmNq"};